import React from 'react'
import { CFooter } from '@coreui/react'

const AppFooter = () => {
  const currentYear = new Date().getFullYear()

  return (
    <CFooter>
      <div>
        <a
          href="https://fera.bio"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-button"
        >
          FeraBiosciences
        </a>
        <span className="ms-1">&copy; {currentYear}</span>
      </div>
      <div className="ms-auto">
        <span className="me-1"></span>
        <a
          href="https://fera.bio"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-button"
        >
          FeraCloud<sup>™</sup> build v1.3.0
        </a>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
